import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationModalInterface } from '../../../interfaces/modal.interface';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomValidator } from '../../validators/custom.validator';

@Component({
  selector: 'confirmation-modal',
  templateUrl: 'confirmation.modal.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  providers: [
    CustomValidator
  ],
})
export class ConfirmationModal {
  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private customValidator: CustomValidator,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationModalInterface,
    public dialogRef: MatDialogRef<ConfirmationModal>
  ) {
    this.form = this.fb.group({
      motivoRifiuto: [''],
    });
  }

  isRequired(controlName: string): boolean {
    const control = this.form.get(controlName);
    return control?.validator?.({} as any)?.['required'];
  }

  ngOnInit(): void {
    if (this.data.isRifiuto) {
      this.form.get('motivoRifiuto')?.setValidators([Validators.required, Validators.maxLength(500), this.customValidator.noWhiteSpace()]);
    }
  }

  reject(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    if (this.data.isRifiuto && this.form.valid) {
      this.dialogRef.close(this.form.get('motivoRifiuto')?.value);
    } else if (!this.data.isRifiuto) {
      this.dialogRef.close(true);
    }
  }
}
